export const triggerStorageEvent = (
  key: string,
  oldValue: string | null,
  newValue: string | null,
) => {
  const event = new StorageEvent('storage', {
    key,
    oldValue,
    newValue,
    storageArea: sessionStorage,
    url: window.location.href,
  });
  window.dispatchEvent(event);
};
